<template>
  <div class="custumer-personal-operateImpactFactors">
    <div class="module-title">网约运营态度</div>
    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 昨日平均出车时长 -->
        <HorizontalCardStyle1
          :title="workDurationData.title"
          :dataDesc="workDurationData.dataDesc"
          :dataUpdateTime="workDurationData.dataUpdateTime"
          :primaryDataList="workDurationData.primaryDataList"
          :secondaryDataList="workDurationData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 昨日出车时长分布 -->
        <GradeBar
          class="mb16"
          :title="workDurationDistributionData.title"
          :dataDesc="workDurationDistributionData.dataDesc"
          :dataUpdateTime="workDurationDistributionData.dataUpdateTime"
          :legendsData="workDurationDistributionData.legendsData"
          :data="workDurationDistributionData.data"
          :tooltip="workDurationDistributionData.tooltip"
        />
      </el-col>
    </el-row>

    <div class="module-title">网约运营效率</div>
    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 平均TPH -->
        <HorizontalCardStyle2
          :title="tphData.title"
          :dataDesc="tphData.dataDesc"
          :dataUpdateTime="tphData.dataUpdateTime"
          :primaryDataList="tphData.primaryDataList"
          :secondaryDataList="tphData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 平均IPH -->
        <HorizontalCardStyle2
          :title="iphData.title"
          :dataDesc="iphData.dataDesc"
          :dataUpdateTime="iphData.dataUpdateTime"
          :primaryDataList="iphData.primaryDataList"
          :secondaryDataList="iphData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 昨日TPH分布 -->
        <GradeBar
          class="mb16"
          :title="tphDistributionData.title"
          :dataDesc="tphDistributionData.dataDesc"
          :dataUpdateTime="tphDistributionData.dataUpdateTime"
          :legendsData="tphDistributionData.legendsData"
          :data="tphDistributionData.data"
          :tooltip="tphDistributionData.tooltip"
        />
      </el-col>
    </el-row>

    <div class="module-title">网约运营服务质量</div>
    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 司机应答后平均取消率 -->
        <HorizontalCardStyle2
          class="mb16"
          :title="cancelRateData.title"
          :dataDesc="cancelRateData.dataDesc"
          :dataUpdateTime="cancelRateData.dataUpdateTime"
          :primaryDataList="cancelRateData.primaryDataList"
          :secondaryDataList="cancelRateData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 昨日服务分分布 -->
        <GradeBar
          class="mb16"
          :title="scoreDistributionData.title"
          :dataDesc="scoreDistributionData.dataDesc"
          :dataUpdateTime="scoreDistributionData.dataUpdateTime"
          :legendsData="scoreDistributionData.legendsData"
          :data="scoreDistributionData.data"
          :tooltip="scoreDistributionData.tooltip"
        />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import HorizontalCardStyle1 from '@/bizComponents/Dashboard/cards/horizontalCard/style1.vue'
import HorizontalCardStyle2 from '@/bizComponents/Dashboard/cards/horizontalCard/style2.vue'
import GradeBar from '@/bizComponents/Dashboard/gradeBar/index.vue'
// eslint-disable-next-line import/no-cycle
import { getPersonOperateImpactFactors } from '@/api/domain/customers'
import { WORK_DURATION_LIST, TPH_LIST, SERVICE_SCORE_LIST } from '../../../customerOperate/list/config'

export default {
  components: {
    HorizontalCardStyle1,
    HorizontalCardStyle2,
    GradeBar,
  },
  provide() {
    return {
      ratioConfig: {
        showRatio: true,
      },
    }
  },
  data() {
    const { spId = '' } = this.$route.query

    return {
      spId,
      // 昨日平均出车时长
      workDurationData: {
        title: '昨日平均出车时长',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 昨日出车时长分布
      workDurationDistributionData: {
        title: '昨日出车时长分布',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        legendsData: [],
        data: [],
        tooltip: `查询日期当天，出车车辆的出车时长分布情况：<br>
          极少：【0，3）小时<br>
          较少：【3，6）小时<br>
          一般：【6，8）小时<br>
          较多：【8，10）小时<br>
          极多：【10，24】小时`,
      },
      // 平均TPH
      tphData: {
        title: '平均TPH',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 平均IPH
      iphData: {
        title: '平均IPH',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 昨日TPH分布
      tphDistributionData: {
        title: '昨日TPH分布',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        legendsData: [],
        data: [],
        tooltip: `查询日期当天，车辆TPH的分布情况：<br/>
          极低：【0，0.5）<br/>
          较低：【0.5，1）<br/>
          一般：【1，1.5）<br/>
          较高：【1.5，2）<br/>
          极高：【2以上】`,
      },
      // 司机应答后平均取消率
      cancelRateData: {
        title: '司机应答后平均取消率',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 昨日服务分分布
      scoreDistributionData: {
        title: '昨日服务分分布',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        legendsData: [],
        data: [],
        tooltip: `查询日期当天，服务分的分布情况：<br/>
          极低：【0，180）<br/>
          较低：【180，270）<br/>
          一般：【270，360）<br/>
          较高：【360，450）<br/>
          极高：【450，540】`,
      },
    }
  },
  created() {
    this.getPersonOperateImpactFactors()
  },
  methods: {
    toCustomerOperateList(params = {}) {
      const spId = this.spId || undefined

      this.$router.push({
        path: '/driver/linkage/customerOperate/list',
        query: {
          spId,
          ...params,
        },
      })
    },
    async getPersonOperateImpactFactors() {
      const res = await getPersonOperateImpactFactors({
        spId: this.spId,
      })

      const { code, data } = res

      if (code === 1) {
        // 昨日平均出车时长
        this.workDurationData.dataUpdateTime = data?.updateTime || ''
        this.workDurationData.primaryDataList = [
          {
            label: '昨日平均出车时长(小时)',
            value: data?.operateAttitude?.yesterdayAveWorkDurationInfo?.value || '--',
            tooltip: `查询日期当天，出车车辆的平均出车时长等级：<br/>
              极少：【0，3）小时<br/>
              较少：【3，6）小时<br/>
              一般：【6，8）小时<br/>
              较多：【8，10）小时<br/>
              极多：【10，24】小时`,
            unit: '',
            ratioList: [
              {
                name: '日环比',
                value: data?.operateAttitude?.yesterdayAveWorkDurationInfo?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.operateAttitude?.yesterdayAveWorkDurationInfo?.weekYoY,
              },
            ],
          },
        ]
        this.workDurationData.secondaryDataList = [
          {
            label: '昨日平均高峰出车时长占比',
            value: ((data?.operateAttitude?.yesterdayAveBusyDurationInfo?.value || 0) * 100).toFixed(2),
            tooltip: '查询日期当天，高峰出车时长占总出车时长比例',
            unit: '%',
            ratioList: [
              {
                name: '日环比',
                value: data?.operateAttitude?.yesterdayAveBusyDurationInfo?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.operateAttitude?.yesterdayAveBusyDurationInfo?.weekYoY,
              },
            ],
          },
          {
            label: '昨日平均服务时长占比',
            value: ((data?.operateAttitude?.yesterdayAveServiceDurationInfo?.value || 0) * 100).toFixed(2),
            tooltip: '查询日期当天，服务时长占总出车时长比例',
            unit: '%',
            ratioList: [
              {
                name: '日环比',
                value: data?.operateAttitude?.yesterdayAveServiceDurationInfo?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.operateAttitude?.yesterdayAveServiceDurationInfo?.weekYoY,
              },
            ],
          },
        ]

        // 昨日出车时长分布
        this.workDurationDistributionData.dataUpdateTime = data?.updateTime || ''
        this.workDurationDistributionData.data = (data?.operateAttitude?.yesterdayAveWorkDurationDistribution || WORK_DURATION_LIST.map((item) => ({ name: item.name }))).map((item, index) => {
          return {
            name: item.levelName || item.name || '',
            data: [
              {
                ratio: item.proportion || 0,
                data: [
                  {
                    type: 'number',
                    name: '人数',
                    value: item.value || 0,
                    clickCallback: () => this.toCustomerOperateList({
                      yesterdayWorkDuration: index + 1,
                    }),
                  },
                  {
                    type: 'ratio',
                    name: '占比',
                    value: item.proportion || 0,
                  },
                ],
              },
            ],
          }
        })

        // 平均TPH
        this.tphData.dataUpdateTime = data?.updateTime || ''
        this.tphData.primaryDataList = [
          {
            label: '昨日平均TPH(单/小时)',
            value: data?.operateEfficiency?.yesterdayAveTPH?.value || '--',
            tooltip: `昨日平均TPH = 查询日期当日，总完单量/出车车辆总出车时长，计算结果展示对应等级：<br/>
              极低：【0，0.5）<br/>
              较低：【0.5，1）<br/>
              一般：【1，1.5）<br/>
              较高：【1.5，2）<br/>
              极高：2以上
            `,
            unit: '',
            ratioList: [
              {
                name: '日环比',
                value: data?.operateEfficiency?.yesterdayAveTPH?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.operateEfficiency?.yesterdayAveTPH?.weekYoY,
              },
            ],
          },
          {
            label: '本周平均TPH(单/小时)',
            value: data?.operateEfficiency?.weekAveTPH?.value || '--',
            tooltip: `本周平均TPH = 查询日期当周，总完单量/出车车辆总出车时长，计算结果展示对应等级：<br/>
              极低：【0，0.5）<br/>
              较低：【0.5，1）<br/>
              一般：【1，1.5）<br/>
              较高：【1.5，2）<br/>
              极高：2以上`,
            unit: '',
            ratioList: [],
          },
          {
            label: '本月平均TPH(单/小时)',
            value: data?.operateEfficiency?.monthAveTPH?.value || '--',
            tooltip: `本月平均TPH=查询日期当月，总完单量/出车车辆总出车时长，计算结果展示对应等级：<br/>
              极低：【0，0.5）<br/>
              较低：【0.5，1）<br/>
              一般：【1，1.5）<br/>
              较高：【1.5，2）<br/>
              极高：2以上
            `,
            unit: '',
            ratioList: [],
          },
        ]

        // 平均IPH
        this.iphData.dataUpdateTime = data?.updateTime || ''
        this.iphData.primaryDataList = [
          {
            label: '昨日平均IPH(元/小时)',
            value: data?.operateEfficiency?.yesterdayAveIPH?.value || '--',
            tooltip: `昨日平均IPH = 查询日期当期，车辆收入总和/出车车辆总出车时长，计算结果展示对应等级：<br/>
              *单个车辆总收入包括司机抽佣金额+活动奖励收入+人工调账金额+司机罚款+取消费<br/>
              极低：【0，30）<br/>
              较低：【30，60）<br/>
              一般：【60，90）<br/>
              较高：【90，120）<br/>
              极高：120以上`,
            unit: '',
            ratioList: [
              {
                name: '日环比',
                value: data?.operateEfficiency?.yesterdayAveIPH?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.operateEfficiency?.yesterdayAveIPH?.weekYoY,
              },
            ],
          },
          {
            label: '本周平均IPH(元/小时)',
            value: data?.operateEfficiency?.weekAveIPH?.value || '--',
            tooltip: `本周平均IPH=查询日期当周，车辆收入总和/出车车辆总出车时长，计算结果展示对应等级：<br/>
              *单个车辆总收入包括司机抽佣金额+活动奖励收入+人工调账金额+司机罚款+取消费<br/>
              极低：【0，30）<br/>
              较低：【30，60）<br/>
              一般：【60，90）<br/>
              较高：【90，120）<br/>
              极高：120以上`,
            unit: '',
            ratioList: [],
          },
          {
            label: '本月平均IPH(元/小时)',
            value: data?.operateEfficiency?.monthAveIPH?.value || '--',
            tooltip: `本月平均IPH=查询日期当月，车辆收入总和/出车车辆总出车时长，计算结果展示对应等级：<br/>
              *单个车辆总收入包括司机抽佣金额+活动奖励收入+人工调账金额+司机罚款+取消费<br/>
              极低：【0，30）<br/>
              较低：【30，60）<br/>
              一般：【60，90）<br/>
              较高：【90，120）<br/>
              极高：120以上`,
            unit: '',
            ratioList: [],
          },
        ]

        // 昨日TPH分布
        this.tphDistributionData.dataUpdateTime = data?.updateTime || ''
        this.tphDistributionData.data = (data?.operateEfficiency?.yesterdayTPHDistribution || TPH_LIST.map((item) => ({ name: item.name }))).map((item, index) => {
          return {
            name: item.levelName || item.name || '',
            data: [
              {
                ratio: item.proportion || 0,
                data: [
                  {
                    type: 'number',
                    name: '人数',
                    value: item.value || 0,
                    clickCallback: () => this.toCustomerOperateList({
                      yesterdayTPH: index + 1,
                    }),
                  },
                  {
                    type: 'ratio',
                    name: '占比',
                    value: item.proportion || 0,
                  },
                ],
              },
            ],
          }
        })

        // 司机应答后平均取消率
        this.cancelRateData.dataUpdateTime = data?.updateTime || ''
        this.cancelRateData.primaryDataList = [
          {
            label: '昨日平均取消率',
            value: data?.operateServiceQuality?.yesterdayAveCancelRate?.value || '--',
            tooltip: `司机应答后司机取消率 = ∑（单人取消订单数/单人应答订单数）/出车司机数，计算结果展示对应等级：<br/>
              较低：【0%，20%）<br/>
              一般：【20%，40%）<br/>
              较高：【40%，60%）<br/>
              极高：【60%，100%】`,
            unit: '',
            ratioList: [
              {
                name: '日环比',
                value: data?.operateServiceQuality?.yesterdayAveCancelRate?.dayRadio,
              },
              {
                name: '周同比',
                value: data?.operateServiceQuality?.yesterdayAveCancelRate?.weekYoY,
              },
            ],
          },
          {
            label: '本周平均取消率',
            value: data?.operateServiceQuality?.weekAveCancelRate?.value || '--',
            tooltip: `司机应答后司机取消率 = ∑（单人取消订单数/单人应答订单数）/出车司机数，计算结果展示对应等级：<br/>
              较低：【0%，20%）<br/>
              一般：【20%，40%）<br/>
              较高：【40%，60%）<br/>
              极高：【60%，100%】`,
            unit: '',
            ratioList: [],
          },
          {
            label: '本月平均取消率',
            value: data?.operateServiceQuality?.monthAveCancelRate?.value || '--',
            tooltip: `司机应答后司机取消率 = ∑（单人取消订单数/单人应答订单数）/出车司机数，计算结果展示对应等级：<br/>
              较低：【0%，20%）<br/>
              一般：【20%，40%）<br/>
              较高：【40%，60%）<br/>
              极高：【60%，100%】`,
            unit: '',
            ratioList: [],
          },
        ]

        // 昨日服务分分布
        this.scoreDistributionData.dataUpdateTime = data?.updateTime || ''
        this.scoreDistributionData.data = (data?.operateServiceQuality?.yesterdayServiceScoreDistribution || SERVICE_SCORE_LIST.map((item) => ({ name: item.name }))).map((item, index) => {
          return {
            name: item.levelName || item.name || '',
            data: [
              {
                ratio: item.proportion || 0,
                data: [
                  {
                    type: 'number',
                    name: '人数',
                    value: item.value || 0,
                    clickCallback: () => this.toCustomerOperateList({
                      yesterdayServiceScore: index + 1,
                    }),
                  },
                  {
                    type: 'ratio',
                    name: '占比',
                    value: item.proportion || 0,
                  },
                ],
              },
            ],
          }
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt24 {
  margin-top: 24px;
}
.module-title {
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #3D3D3D;
}
</style>
